import { bool, shape, string, func, node } from "prop-types";

export const backProptypes = {
    /**
     * back link url
     */
    backLinkTo: string,
    /**
     * back function, ignored if backLinkTo is specified
     */
    onBack: func,
};

export const backDefaultProps = {
    backLinkTo: null,
    onBack: null,
    showLabel: true,
};

export const componentPropTypes = {
    ...backProptypes,
    fetchingDownload: bool,
    onClickDownloadPDF: func,
    onClickDownloadXLS: func,
    renderDownload: func,
    handleOptionsClick: func,
    isDesktop: bool.isRequired,
    infoComponent: shape({
        data: node,
    }),
    children: node.isRequired,
};

export const defaultPropTypes = {
    ...backDefaultProps,
    onClickDownloadPDF: null,
    onClickDownloadXLS: null,
    renderDownload: null,
    handleOptionsClick: null,
    infoComponent: null,
    fetchingDownload: false,
};
